// extracted by mini-css-extract-plugin
export default {"container":"Cafe2_container__dgwJf","info":"Cafe2_info__+rpnj","comp":"Cafe2_comp__iz4JZ","txt":"Cafe2_txt__bYOy4"};